/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  List,
  OrganizationSCIMConnection,
  OrganizationSCIMConnectionWithToken,
  SCIMConnectionLabel,
  SCIMConnectionProvider,
} from "./data-contracts";

/**
 * No description
 * @tags scim
 * @name ListOrganizationScimConnections
 * @summary List SCIM connections
 * @request GET:/orgs/{organizationId}/scim/connections
 * @secure
 */

// @ts-ignore
export const listOrganizationSCIMConnections: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: OrganizationSCIMConnection[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/scim/connections",
  method: "get",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a SCIM connection and its token. The token is only returned in this response.
 * @tags scim
 * @name CreateOrganizationScimConnection
 * @summary Create a SCIM connection
 * @request POST:/orgs/{organizationId}/scim/connections
 * @secure
 */

// @ts-ignore
export const createOrganizationSCIMConnection: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the SCIM connection, shown to organization admins. */
    label: SCIMConnectionLabel;
    /** Identity provider that provisions members through the SCIM connection. */
    provider: SCIMConnectionProvider;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationSCIMConnectionWithToken;
  ResponseStatusCode: 201 | 400 | 404 | 412;
} = {
  route: "/orgs/{organizationId}/scim/connections",
  method: "post",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags scim
 * @name GetOrganizationScimConnection
 * @summary Get a SCIM connection by its ID
 * @request GET:/orgs/{organizationId}/scim/connections/{scimConnectionId}
 * @secure
 */

// @ts-ignore
export const getOrganizationSCIMConnection: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SCIM connection */
    scimConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationSCIMConnection;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
  method: "get",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags scim
 * @name UpdateOrganizationScimConnection
 * @summary Update a SCIM connection
 * @request PATCH:/orgs/{organizationId}/scim/connections/{scimConnectionId}
 * @secure
 */

// @ts-ignore
export const updateOrganizationSCIMConnection: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SCIM connection */
    scimConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the SCIM connection, shown to organization admins. */
    label: SCIMConnectionLabel;
  };
  RequestHeaders: {};
  ResponseBody: OrganizationSCIMConnection;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
  method: "patch",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Deletes a SCIM connection. Its token stops working immediately.
 * @tags scim
 * @name DeleteOrganizationScimConnection
 * @summary Delete a SCIM connection
 * @request DELETE:/orgs/{organizationId}/scim/connections/{scimConnectionId}
 * @secure
 */

// @ts-ignore
export const deleteOrganizationSCIMConnection: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SCIM connection */
    scimConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 404;
} = {
  route: "/orgs/{organizationId}/scim/connections/{scimConnectionId}",
  method: "delete",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Replaces the token of a SCIM connection. The previous token stops working immediately, and the new token is only returned in this response.
 * @tags scim
 * @name RotateOrganizationScimConnectionToken
 * @summary Rotate the token of a SCIM connection
 * @request POST:/orgs/{organizationId}/scim/connections/{scimConnectionId}/token
 * @secure
 */

// @ts-ignore
export const rotateOrganizationSCIMConnectionToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the SCIM connection */
    scimConnectionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationSCIMConnectionWithToken;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/scim/connections/{scimConnectionId}/token",
  method: "post",
  streaming: false,
  tags: ["scim"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
